import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectTo: React.FC<{ to: string }> = ({ to }) => <Navigate to={to} replace />;

export default RedirectTo;
